// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1eaAa","inner":"Footer_inner__3ht9V"};